<template>
  <c-view>
    <c-page>
      <div v-show="!sendSuccess" class="text-color white text-center verify-container">
        <div class="navbar-panel">
          安全验证
        </div>
        <div class="mt-30 middle-text">
          验证短信已发送至
        </div>
        <div class="mt-20 telephone">
          {{ formItem.telephoneNum | secretPhoneNum}}
        </div>
        <div class="codeInput">
          <div class="code" v-for="(item, index) in showVerifyCodes" :key="index">
            {{ item }}
          </div>
        </div>
        <div class="mt-30 info">
          <div v-if="this.formItem.codeWorking">
            {{formItem.timeSecond}}后可重新发送
          </div>
          <div v-else>
            未收到验证短信？ <a href="javascript:void(0)" class="text-color white resend-code" @click="resendCode()">重新发送</a>
          </div>
        </div>
      </div>
    </c-page>
    <c-keyboard v-show="!sendSuccess" @key-press="pushCode" @key-del="deleteCode"></c-keyboard>
  </c-view>
</template>
<style lang="scss" scoped>
  @import './index.scss';
</style>
<script>
  import SignUpModel from '../../model/alpha-sign-up/form'
  import CKeyboard from '../temp'

  export default {
    data () {
      const formModel = new SignUpModel()
      return {
        formModel,
        formItem: formModel.formItem,
        verifyCodes: [],
        sendSuccess: false
      }
    },
    components: {CKeyboard},
    created () {
    },
    mounted () {
      this.formModel.fireTimer()
      this.formModel.initFormData(this.$route.query)
      if (Object.keys(this.$route.query).length === 0) {
        this.sendSuccess = true
        this.$router.push({path: '/sign-up'})
      }
    },
    beforeDestroy () {
    },
    methods: {
      pushCode (value) {
        if (this.verifyCodes.length === 6) return
        this.verifyCodes.push(value)
      },
      deleteCode () {
        if (this.verifyCodes.length === 0) return
        this.verifyCodes.pop()
      },
      checkVerify () {
        return new Promise(resolve => {
          this.formModel.checkVertifyCode().then(res => {
            let data = res
            console.log('data', data)
            if (data === 0) {
              resolve(true)
            } else if (data === -2) {
              this.$wejs.toast('验证失败', {
                className: 's-toast-error'
              })
              resolve(false)
            }
          })
        })
      },
      resendCode () {
        console.log('重新发送')
        if (!this.formItem.telephoneNum) {
          this.$wejs.alert('抱歉发送出错', () => {
            this.$router.push({path: '/alpha-sign-up'})
          })
        }
        this.formModel.getVerifyCode().then((v) => {
          if (v === 0) {
            this.formModel.fireTimer()
            this.$wejs.toast('验证码已发送')
            this.formItem.codeWorking = true
          }
        }).catch((e) => {
          console.log(e)
        })
      },
      submitSignUpFunc () {
        this.formItem.signuping = true
        let handler = this.$wejs.loading('注册中')
        this.formModel.submitSignup().then(res => {
          let data = res
          handler.hide()
          if (data === 0) {
            this.$wejs.toast('注册成功', {
              className: 's-toast-success',
              duration: 3000
            })
            this.$router.replace({name: 'SignupStatus'})
          } else {
            this.$wejs.toast('注册失败', {
              className: 's-toast-error'
            })
          }
        }).catch((e) => {
        })
      },
      submitSignupProcess () {
        this.checkVerify().then(res => {
          if (res) this.submitSignUpFunc()
        })
      }
    },
    computed: {
      showVerifyCodes () {
        let code = Array(6).fill(null)
        this.verifyCodes.forEach((item, index) => {
          code[index] = item
        })
        return code
      }
    },
    watch: {
      verifyCodes (val) {
        this.formItem.codeNum = val.join('')
        if (this.formItem.codeNum && this.formItem.codeNum.length === 6) {
          this.submitSignupProcess()
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// index.vue?6fcaf779